const Member_Visible_DATA = [
  {
    key: "Visible",
    value: 1,
    text: "是"
  },
  {
    key: "Disvisible",
    value: 0,
    text: "否"
  }
];
const Member_Visible = {};
const Member_Visible_TEXT = {};
for (let item of Member_Visible_DATA) {
  Member_Visible[item.key] = item.value;
  Member_Visible_TEXT[item.value] = item.text;
}
export { Member_Visible, Member_Visible_TEXT };
